import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormsModule } from '@angular/forms';
import { MatMenu, MatMenuTrigger } from '@angular/material/menu';
import { TranslateModule } from '@ngx-translate/core';
import { Dayjs } from 'dayjs';
import { ELoadStatus } from '../../../state/state.interface';
import { DateUtilitiesService } from '../../../utilities/date-utilities.service';
import { InlineMenuPositionService } from '../../../utilities/inline-menu-position.service';
import { DateRangePickerComponent } from '../date-range-picker/date-range-picker.component';
import { IDateRangePickerDate } from '../date-range-picker/date-range-picker.interface';
import { InlineDatePickerStore } from './inline-date-picker.store';

@Component({
  imports: [TranslateModule, MatMenuTrigger, MatMenu, FormsModule, DateRangePickerComponent],
  providers: [InlineDatePickerStore],
  selector: 'app-inline-date-picker',
  styleUrls: ['./inline-date-picker.component.scss'],
  templateUrl: './inline-date-picker.component.html',
})
export class InlineDatePickerComponent implements OnInit, AfterViewInit {
  @ViewChild('menuTrigger') menuTrigger!: MatMenuTrigger;
  @ViewChild('inlineDatePicker') child!: DateRangePickerComponent;
  @Input() itemId: number | null = null;
  @Input() date: string | null = null;
  @Output() triggerRefresh = new EventEmitter<void>();

  public menuYPosition: 'above' | 'below' = 'below';

  public formControl: FormControl<IDateRangePickerDate | null | undefined> = new FormControl<
    IDateRangePickerDate | null | undefined
  >(null);

  public formattedDate = {
    endDate: null as Dayjs | null,
    startDate: null as Dayjs | null,
  };

  constructor(
    public readonly store: InlineDatePickerStore,
    public readonly inlineMenuPositionService: InlineMenuPositionService,
  ) {}

  public ngOnInit(): void {
    this.store.editItemLoading$.subscribe((status) => {
      if (status === ELoadStatus.success) {
        this.triggerRefresh.emit();
      }
    });
  }

  public triggerDatePickerOpen(): void {
    if (this.date) {
      this.formattedDate = {
        endDate: DateUtilitiesService.convertUTCToUserTimezone(this.date),
        startDate: DateUtilitiesService.convertUTCToUserTimezone(this.date),
      };

      this.formControl.setValue(this.formattedDate);
    }

    setTimeout(() => {
      this.child?.openDatepicker();
    });
  }

  public datesChange(dates: IDateRangePickerDate | undefined): void {
    if (!dates?.startDate || !this.itemId) {
      return;
    }

    this.store.editItemDueDate({
      dueDate: dates.startDate.toISOString(),
      id: this.itemId,
    });
  }

  public ngAfterViewInit(): void {
    this.menuTrigger.menuOpened.subscribe(() => {
      setTimeout(() => {
        this.triggerDatePickerOpen();
      });
    });
  }

  public setMenuPosition(triggerElem: HTMLElement): void {
    const { yPosition } = this.inlineMenuPositionService.calculateMenuPosition(triggerElem);
    this.menuYPosition = yPosition;
  }

  public onTriggerClick(triggerElem: HTMLElement): void {
    this.setMenuPosition(triggerElem);

    this.menuTrigger.openMenu();
  }
}
